import { useColorMode } from '@chakra-ui/react';
import React from 'react';

type Themable = { theme?: any };

function wrapColorTheme<Props extends Themable>(Component: React.FunctionComponent<Props>) {
  function ColorThemeWrapper(props: Props) {
    const { colorMode } = useColorMode();
    const themedProps: Props = { ...props, theme: colorMode } as Props;

    return <Component {...themedProps} />;
  }

  return ColorThemeWrapper;
}

export default wrapColorTheme;
